import L from "leaflet";
import ReactDOMServer from "react-dom/server";
import { FaExclamationTriangle } from "react-icons/fa";
import "../../styles/icons.css";

/**
 * Helper to create a PIN-style marker
 */
const createIcon = (bgColor, color, extraClass = "") =>
  L.divIcon({
    className: `custom-marker ${extraClass}`,
    html: ReactDOMServer.renderToString(
      <div className="marker-wrapper">
        <div
          className="marker-head"
          style={{
            background: bgColor,
            color: color,
            border: `2px solid ${color}`,
          }}
        >
          <FaExclamationTriangle size={16} />
        </div>

        <div
          className="marker-tip"
          style={{
            borderTop: `12px solid ${bgColor}`,
          }}
        />

        <div className="marker-shadow" />
      </div>,
    ),
    iconSize: [32, 42],
    iconAnchor: [16, 42],
    popupAnchor: [0, -36],
  });

/**
 * Default marker (primary)
 */
export const DefaultIcon = createIcon("var(--info-color)", "white");

/**
 * Approved incidents (green)
 */
export const IncidentIcon = createIcon("var(--success-color)", "white");

/**
 * Pending incidents (red)
 */
export const PendingIncidentIcon = createIcon(
  "var(--error-color)",
  "white",
  "pulse",
);

/**
 * Set default icon globally
 */
L.Marker.prototype.options.icon = DefaultIcon;
